export const base_url = process.env.REACT_APP_BASE_URL;
// export const base_url='https://8155-103-48-1-30.ngrok-free.app/'
// export const base_url = "https://gigmi2022-dev.s3.amazonaws.com/"
export const bucket_base_url = process.env.REACT_APP_S3_BUCKET_URL;
export const WEATHER_API_KEY = "8314c7b2b0e289d0ec82ed6578962a6a";
export const fire_base_api_key = "AIzaSyCc6Mkyk8KvFEW5UDMtmNDx-jZ2X9WGCTg";
export const dynamic_Link_key = "AIzaSyBmkwhTqZXECq1slpbzY_q2LK4l4kXwl70";
export const google_map_api_key = "AIzaSyBsRWbqWJH4JvWo8y9oiq6Yuz3mro5KVr4";
export const aero_pay_environment = process.env.REACT_APP_AERO_PAY_ENVIRONMENT;
export const consumer_id = process.env.REACT_APP_CONSUMER_ID;
